module.exports = __webpack_public_path__ + "img/ts13.2d0a4188.png";